import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { CaptchaService } from 'src/app/services/captcha.service';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
})
export class CaptchaComponent implements AfterViewInit, OnDestroy {
  @ViewChild('invisible') invisible: RecaptchaComponent;
  siteKey = environment.recaptchaSiteKey;

  constructor(private captchaService: CaptchaService) {}

  ngAfterViewInit() {
    if (this.invisible) {
      this.captchaService.registerWidget(this.invisible);
    }
  }

  ngOnDestroy() {
    this.captchaService.unregisterWidget(this.invisible);
  }

  handleCaptchaResolved(captchaResponse: string | null) {
    this.captchaService.handleCaptchaResolved(captchaResponse);
  }

  handleCaptchaExpired() {
    this.captchaService.handleCaptchaExpired();
  }

  handleCaptchaError() {
    this.captchaService.handleCaptchaError();
  }
}